import * as React from "react";
import { socialIcons, socialNetworkNames, SocialNetworksId } from "../../interfaces";
import { Image, SemanticSIZES } from "semantic-ui-react";

import "./styles.scss";
interface Props {
  socialNetworkId: SocialNetworksId;
  size?: SemanticSIZES;
}

export const SocialNetworkIcon: React.FC<Props> = ({ socialNetworkId, size = "large" }) => {
  return (
    <Image
      src={socialIcons[socialNetworkId]}
      title={socialNetworkNames[socialNetworkId]}
      className={`socialNetworkIcon ${size}`}
      circular
      size="mini"
    />
  );
};
